export const getInitialState = (): any => ({
  dataProcessingMergeData: {},
  dataProcessingMergeStatus: 0
});
